import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card';
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Moon, Bell, FileCheck } from 'lucide-react';

const SettingsPage = () => {
    const DisabledSwitch = ({ id }) => (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div>
                        <Switch
                            id={id}
                            checked={false}
                            disabled={true}
                            className="cursor-not-allowed"
                        />
                    </div>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Feature coming soon</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );

    return (
        <div className="max-w-3xl mx-auto px-4 py-8 space-y-6">
            <div className="flex items-center justify-between">
                <h1 className="text-3xl font-bold">Settings</h1>
            </div>

            <Card>
                <CardHeader>
                    <CardTitle>Appearance</CardTitle>
                    <CardDescription>
                        Customize how the application looks and feels.
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <Moon className="h-4 w-4 text-gray-500" />
                            <Label htmlFor="dark-mode">Dark Mode</Label>
                        </div>
                        <DisabledSwitch id="dark-mode" />
                    </div>
                </CardContent>
            </Card>

            <Card>
                <CardHeader>
                    <CardTitle>Notifications</CardTitle>
                    <CardDescription>
                        Configure how you want to be notified about important updates.
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <Bell className="h-4 w-4 text-gray-500" />
                            <div className="space-y-1">
                                <Label htmlFor="email-notifications">Email Notifications</Label>
                                <p className="text-sm text-gray-500">
                                    Receive important updates about your account via email.
                                </p>
                            </div>
                        </div>
                        <DisabledSwitch id="email-notifications" />
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <FileCheck className="h-4 w-4 text-gray-500" />
                            <div className="space-y-1">
                                <Label htmlFor="analysis-notifications">Analysis Notifications</Label>
                                <p className="text-sm text-gray-500">
                                    Get notified when your website analyses are complete.
                                </p>
                            </div>
                        </div>
                        <DisabledSwitch id="analysis-notifications" />
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default SettingsPage;